import ContractCargoTaxiUpdateRequest from "../../../../api/raily/contracts/cargo-taxi/update/contracts-cargo-taxi-update.request";
import ContractsCargoTaxiUpdateParams from "./contracts-cargo-taxi-update-params";

const create = (
  params: ContractsCargoTaxiUpdateParams,
): ContractCargoTaxiUpdateRequest => {
  return {
    disabled: !params.isActive,
    contractId: params.contractUuid,
    contactPassengerAfterMinutes: params.contactPassengerAfterMinutes,
    cancelOrderByTaxiAllowed: params.cancelOrderByTaxiAllowed,
    editOrderByTaxiAllowed: params.editOrderByTaxiAllowed,
    autoApprovalMinDistance: params.autoApprovalMinDistance,
    autoApprovalSwitch: params.autoApprovalSwitch,
    autoApprovalMinTime: params.autoApprovalMinTime,
    approvalDeadlineSwitch: params.approvalDeadlineSwitch,
    approvalDeadlineTime: params.approvalDeadlineTime,
  };
};

const contractsCargoTaxiUpdateRequestFactory = {
  create,
};

export default contractsCargoTaxiUpdateRequestFactory;
